import { FieldSectionType } from 'api/field-sections/types';
import { Field } from 'api/tasks';
import { FieldType } from 'components/organisms/tasks/fields';
import { STATUS_FIELD_NAME } from 'data/fields/hooks';
import { useTranslation } from 'hooks/use-translation';
import { byFieldName } from 'utils/by-field-name';
import { unreachable } from 'utils/unreachable';
import {
  ArrField,
  DueDateField,
  ProjectFeeField,
  StartDateField,
  StatusField,
} from './fields';

export type Renderer = React.FunctionComponent<any> | null;

export const getDefaultProjectFieldRenderer = (field: Field): Renderer => {
  const { fieldName } = field;

  switch (fieldName) {
    case 'Status':
      return StatusField;
    case 'startDate':
      return StartDateField;
    case 'dueDate':
      return DueDateField;
    case 'arr':
    case 'annualizedRecurringRevenue':
      return ArrField;
    case 'projectFee':
      return ProjectFeeField;
    default:
      return unreachable(fieldName as never);
  }
};

export const ComputeDefaultProjectFields = (fields: Field[]): Field[] => {
  const statusField = fields.find((field) => {
    return byFieldName(field, STATUS_FIELD_NAME);
  });
  const startDate: Field = {
    customField: false,
    fieldId: -1,
    fieldName: 'startDate',
    fieldLabel: useTranslation('start_date'),
    fieldType: FieldType.Date,
    isEnabled: true,
    fieldDataType: 'DATE',
    private: false,
    optionsAvailable: false,
    objectType: FieldSectionType.Project,
  };
  const dueDate: Field = {
    customField: false,
    fieldId: -2,
    fieldName: 'dueDate',
    fieldLabel: useTranslation('due_date'),
    fieldType: FieldType.Date,
    isEnabled: true,
    fieldDataType: 'DATE',
    private: false,
    optionsAvailable: false,
    objectType: FieldSectionType.Project,
  };
  const arr: Field = {
    customField: false,
    fieldId: -3,
    fieldName: 'arr',
    fieldLabel: useTranslation('arr'),
    fieldType: FieldType.Number,
    isEnabled: true,
    fieldDataType: 'number',
    private: false,
    optionsAvailable: false,
    objectType: FieldSectionType.Project,
  };
  const projectFee: Field = {
    customField: false,
    fieldId: -4,
    fieldName: 'projectFee',
    fieldLabel: useTranslation('project_fee'),
    fieldType: FieldType.Number,
    isEnabled: true,
    fieldDataType: 'number',
    private: false,
    optionsAvailable: false,
    objectType: FieldSectionType.Project,
  };
  const defaultFieldsList = [startDate, dueDate, arr, projectFee] as Field[];

  if (statusField) {
    defaultFieldsList.unshift(statusField);
  }

  return defaultFieldsList;
};
